import { gql } from 'apollo-angular';

export const GET_PRIMARY_CATEGORIES = gql`
  query primaryCategories {
    primaryCategories {
      id
      name
      type
      categorizationScheme {
        id
        name
      }
    }
  }
`;

export default GET_PRIMARY_CATEGORIES;
